import React, { useRef } from 'react'
import TextEditor from '../../../../../../../../../../shared-components/TextEditor';
import RangeOfMotion from './RangeOfMotion';

const ObjectiveFinding = (props) => {
    //ObjectiveFinding
    let { isExpanded, objectiveData, setObjectiveData, setSaveObjectiveFindingData, setSaveRangeOfMotionData, ObjectiveNotesProps, } = { ...props };
    let objectiveFinding = objectiveData?.ObjectiveFinding;
    let  { handleChangeFreeText, handleItemsExpanded, itemsCollapsed, scrollNavIDs, handleHoveredItem, handleActiveItem,
        PatientName, Age, DOB, Address, MobileNumber, Email, ...rest } = { ... ObjectiveNotesProps };
    const quillPalpationNotesRef = useRef(null);

    const handleObjectiveFinding = (e) => {
        let { name } = e.target;
        console.log("handleObjectiveFindingobjectiveFindingData", name)
        setObjectiveData(prev => {
            return ({
                ...prev,
                'ObjectiveFinding': {
                    ...prev?.ObjectiveFinding,
                    [name]: prev?.ObjectiveFinding?.[name] === "true" ? "false" : "true",
                },
            });
        });

        setSaveObjectiveFindingData(prev => ({
            ...prev,
            [name]: prev[name] === "true" ? "false" : "true"
        }));
    }

  return (
        <>
            <div className="d-flex gap-40">
            <div className="d-flex flex-column gap-2">
                <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                    <input
                        type="checkbox"
                        className="form-check-input m-0 p-0"
                        name="PostureAssessmentOfSpine"
                        checked={objectiveFinding?.PostureAssessmentOfSpine === "true"}
                        onChange={handleObjectiveFinding}
                        />
                </div>
                <p className="text lh-12">Posture Assessment of Spine</p>
                </label>
                <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                    <input 
                        type="checkbox"
                        className="form-check-input m-0 p-0"
                        name="PostureAssessmentOfShoulder"
                        checked={objectiveFinding?.PostureAssessmentOfShoulder === "true"}
                        onChange={handleObjectiveFinding}
                        />
                </div>
                <p className="text lh-12">Posture Assessment of Shoulder</p>
                </label>
            </div>
            <div className="d-flex flex-column gap-2">
                <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                    <input 
                        type="checkbox"
                        className="form-check-input m-0 p-0"
                        name="PostureAssessmentOfPelvis"
                        checked={objectiveFinding?.PostureAssessmentOfPelvis === "true"}
                        onChange={handleObjectiveFinding}
                        />
                </div>
                <p className="text lh-12">Posture Assessment of Pelvis</p>
                </label>
                <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                    <input 
                        type="checkbox"
                        className="form-check-input m-0 p-0"
                        name="RangeOfMotion"
                        checked={objectiveFinding?.RangeOfMotion === "true"}
                        onChange={handleObjectiveFinding}
                        />
                </div>
                <p className="text lh-12">Range of Motion (ROM)</p>
                </label>
            </div>
            <div className="d-flex flex-column gap-2">
                <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                    <input 
                        type="checkbox"
                        className="form-check-input m-0 p-0"
                        name="Palpation"
                        checked={objectiveFinding?.Palpation === "true"}
                        onChange={handleObjectiveFinding}
                        />
                </div>
                <p className="text lh-12">Palpation</p>
                </label>
            </div>
            </div>

            {(objectiveFinding?.PostureAssessmentOfSpine === "true" || 
            objectiveFinding?.Shoulder  === "true" || 
            objectiveFinding?.PostureAssessmentOfPelvis === "true" || 
            objectiveFinding?.RangeOfMotion === "true" || 
            objectiveFinding?.Palpation === 'true')  ?
            <div className="observation-content d-flex flex-column gap-2 Objective-Findings">
                {/* Posture Assessment of Spine */}
                {objectiveFinding?.PostureAssessmentOfSpine === "true" ?
                <div className="d-flex flex-column gap-1">
                    <p className="heading fs-13 lh-normal">Posture Assessment of Spine:</p>
                    <div className="">
                    <table>
                        <thead>
                        <tr>
                            <th className="heading"></th>
                            <th className="heading">SEVERE</th>
                            <th className="heading">MODERATE</th>
                            <th className="heading">MILD</th>
                            <th className="heading">NONE</th>
                        </tr>
                        </thead>
                        <tbody>
                            <TableRow name={'Lordosis'} type={'PAOS'} options={['Severe', 'Moderate', 'Mild', 'None']} setObjectiveData={setObjectiveData} setSaveObjectiveFindingData={setSaveObjectiveFindingData} objectiveFindingData={objectiveFinding}/>
                            <TableRow name={'Kyphosis'} type={'PAOS'} options={['Severe', 'Moderate', 'Mild', 'None']} setObjectiveData={setObjectiveData} setSaveObjectiveFindingData={setSaveObjectiveFindingData} objectiveFindingData={objectiveFinding}/>
                            <TableRow name={'Scoliosis'} type={'PAOS'} options={['Severe', 'Moderate', 'Mild', 'None']} setObjectiveData={setObjectiveData} setSaveObjectiveFindingData={setSaveObjectiveFindingData} objectiveFindingData={objectiveFinding}/>
                        </tbody>
                    </table>
                    </div>
                </div> : <></>}
                {/* Posture Assessment of Pelvis */}
                {objectiveFinding?.PostureAssessmentOfPelvis  === "true" ?
                <div className="d-flex flex-column gap-1">
                    <p className="heading fs-13 lh-normal">Posture Assessment of Pelvis:</p>
                    <div className="">
                    <table>
                        <thead>
                        <tr>
                            <th className="heading"></th>
                            <th className="heading">SEVERE</th>
                            <th className="heading">MODERATE</th>
                            <th className="heading">MILD</th>
                            <th className="heading">NONE</th>
                        </tr>
                        </thead>
                        <tbody>
                            <TableRow name={'Tilt'} type={'PAOP'} options={['Severe', 'Moderate', 'Mild', 'None']} setObjectiveData={setObjectiveData} setSaveObjectiveFindingData={setSaveObjectiveFindingData} objectiveFindingData={objectiveFinding}/>
                            <TableRow name={'Twist'} type={'PAOP'} options={['Severe', 'Moderate', 'Mild', 'None']} setObjectiveData={setObjectiveData} setSaveObjectiveFindingData={setSaveObjectiveFindingData} objectiveFindingData={objectiveFinding}/>
                            <TableRow name={'Protraction'} type={'PAOP'} options={['Severe', 'Moderate', 'Mild', 'None']} setObjectiveData={setObjectiveData} setSaveObjectiveFindingData={setSaveObjectiveFindingData} objectiveFindingData={objectiveFinding}/>
                            <TableRow name={'Retraction'} type={'PAOP'} options={['Severe', 'Moderate', 'Mild', 'None']} setObjectiveData={setObjectiveData} setSaveObjectiveFindingData={setSaveObjectiveFindingData} objectiveFindingData={objectiveFinding}/>
                        </tbody>
                    </table>
                    </div>
                </div> : <></>}
                {/* Posture Assessment of Shoulder */}
                {objectiveFinding?.PostureAssessmentOfShoulder === "true" ?
                <div className="d-flex flex-column gap-1">
                    <p className="heading fs-13 lh-normal">Posture Assessment of Shoulder:</p>
                    <div className="">
                    <table>
                        <thead>
                        <tr>
                            <th className="heading"></th>
                            <th className="heading">SEVERE</th>
                            <th className="heading">MODERATE</th>
                            <th className="heading">MILD</th>
                            <th className="heading">NONE</th>
                        </tr>
                        </thead>
                        <tbody>
                            <TableRow name={'Tilt'} type={'PAOSH'} options={['Severe', 'Moderate', 'Mild', 'None']} setObjectiveData={setObjectiveData} setSaveObjectiveFindingData={setSaveObjectiveFindingData} objectiveFindingData={objectiveFinding}/>
                            <TableRow name={'Twist'} type={'PAOSH'} options={['Severe', 'Moderate', 'Mild', 'None']} setObjectiveData={setObjectiveData} setSaveObjectiveFindingData={setSaveObjectiveFindingData} objectiveFindingData={objectiveFinding}/>
                            <TableRow name={'Protraction'} type={'PAOSH'} options={['Severe', 'Moderate', 'Mild', 'None']} setObjectiveData={setObjectiveData} setSaveObjectiveFindingData={setSaveObjectiveFindingData} objectiveFindingData={objectiveFinding}/>
                        </tbody>
                    </table>
                    </div>
                </div> : <></>}
                {/* Range of Motion (ROM) */}
                {objectiveFinding?.RangeOfMotion === "true" ?
                <RangeOfMotion 
                    setSaveRangeOfMotionData={setSaveRangeOfMotionData} 
                    objectiveData={objectiveData} 
                    setObjectiveData={setObjectiveData} 
                /> : <></>}

                {/* Palpation */}
                {objectiveFinding?.Palpation === 'true' ?
                (<div id={scrollNavIDs.refPALPATIONN} onMouseEnter={() => handleHoveredItem(scrollNavIDs.refPALPATIONN)} onClick={() => handleActiveItem(scrollNavIDs.refPALPATIONN)}>
                    <p className="heading fs-13 cursor-pointer user-select-none w-max-content">Palpation</p>
                    {/* {!itemsCollapsed?.['PalpN'] &&
                        ( */}
                        <div className='mt-1'>
                            <TextEditor
                                quillRef={quillPalpationNotesRef}
                                value={objectiveFinding?.PalpationNotes}
                                setValue={(value) => handleChangeFreeText(value, 'PalpationNotes')}
                                placeholderReplacement={true}
                                customDropDown={{
                                    'active': true,
                                    'options': [
                                        { value: PatientName, display: 'Name', },
                                        { value: Age, display: '$Age', },
                                        { value: DOB, display: '$DOB', },
                                        { value: Address, display: '$Address', },
                                        { value: MobileNumber, display: '$Phone', },
                                        { value: Email, display: '$Email', },
                                    ]
                                }}
                                placeholder={"Palpation..."}
                            />
                        </div>
                    {/*  )} */}
                </div>) : <></>}
            </div> : <></>}
        </>
  )
}

export default ObjectiveFinding

const TableRow = (props) => {
    let { name, type, setObjectiveData, setSaveObjectiveFindingData, options, objectiveFindingData} = props; 
    let fieldStart = `${type}_${name}`;

    const handleSelectOne = (e) => {
        let { name } = e.target;

        const newObj = options.reduce((acc, item) => {
            let fieldName = `${fieldStart}${item}`;// match input name
            acc[fieldName] = fieldName === name ? 'true' : 'false';
            return acc;
        }, {});

    console.log("objectiveFindingData", objectiveFindingData, fieldStart, newObj)

        setObjectiveData(prev => {
            return ({
                ...prev,
                'ObjectiveFinding': {
                    ...prev?.ObjectiveFinding, ...newObj
                },
            });
        });
        setSaveObjectiveFindingData(prev => {
            return ({ ...prev, ...newObj });
        });
    }
    return(
        <tr>
            <td>
            <p className="text">{name}</p>
            </td>
            {options?.length > 0 ? 
            (options?.map(opt => (
                <td key={`${fieldStart}${opt}`}>
                    <label className="ar_radio-btn d-flex justify-content-center">
                        <input
                        type="radio"
                        id={`${fieldStart}${opt}`}
                        name={`${fieldStart}${opt}`}
                        checked={objectiveFindingData?.[`${fieldStart}${opt}`] === 'true' || false}
                        onChange={handleSelectOne}
                        />
                    </label>
                </td>
            ))) : <></>}
            {/* <td>
            <label className="ar_radio-btn d-flex justify-content-center">
                <input
                type="radio"
                id={`${fieldStart}${'Moderate'}`}
                name={`${fieldStart}${'Moderate'}`}
                checked={objectiveFindingData?.[`${fieldStart}${'Moderate'}`] === 'true' || false}
                />
            </label>
            </td>
            <td>
            <label className="ar_radio-btn d-flex justify-content-center">
                <input
                type="radio"
                id={`${fieldStart}${'Mild'}`}
                name={`${fieldStart}${'Mild'}`}
                checked={objectiveFindingData?.[`${fieldStart}${'Mild'}`] === 'true' || false}
                />
            </label>
            </td>
            <td>
            <label className="ar_radio-btn d-flex justify-content-center">
                <input
                type="radio"
                id={`${fieldStart}${'None'}`}
                name={`${fieldStart}${'None'}`}
                checked={objectiveFindingData?.[`${fieldStart}${'None'}`] === 'true' || false}
                />
            </label>
            </td> */}
        </tr>)
}